import "./IphonePro.css";

function IphonePro() {
    return (
        <section className="iphonepro-ipad">
            <div className="container-fluid">
                <div className="row">
                    <div className="iphonepro-wrapper col-md-6 left">
                        <div className="iphonepro cursorP">
                            <div className="name3">iPhone 14 Pro</div>
                            <div className="name4">Pro.Beyond.</div>
                            <div className="links-blue">
                                <ul className="list-inline iphoneproa">
                                    <li className="list-inline-item">
                                        <a href="">Learn more</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="">Buy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="ipad-wrapper col-md-6 right">
                        <div className="ipad-right cursorP">
                            <div className="name3">iPad</div>
                            <div className="name4">
                                Loveable. Drawable. Magical
                            </div>
                            <div className="links-blue">
                                <ul className="list-inline iphoneproa">
                                    <li className="list-inline-item">
                                        <a href="">Learn more</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="">Buy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default IphonePro;
